import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RxDashboard, RxPinLeft } from "react-icons/rx";
import { TbHeartSearch } from "react-icons/tb";
import { LuFolderHeart } from "react-icons/lu";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { RiSettings5Line } from "react-icons/ri";
import { FaUsers, FaProjectDiagram, FaBullhorn, FaComments } from "react-icons/fa";
import { useUser } from "../contextProviders/userContext";

function TopNavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useUser();

  const isLinkActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    await logout();
    navigate("/signin");
  };

  const NavLink = ({ to, icon: Icon, children }) => {
    const active = isLinkActive(to);
    return (
      <Nav.Link
        as={Link}
        to={to}
        className="d-flex align-items-center gap-2"
        style={{
          fontWeight: active ? 600 : 500,
          fontSize: "0.9rem",
          color: active ? "#fff" : "var(--color-text-secondary)",
          backgroundColor: active ? "var(--color-primary)" : "transparent",
          borderRadius: "var(--radius-md)",
          padding: "0.5rem 0.9rem",
          transition: "all var(--transition)",
        }}
      >
        <Icon size={18} />
        <span>{children}</span>
      </Nav.Link>
    );
  };

  return (
    <Navbar
      collapseOnSelect
      expand="md"
      className="d-lg-none mb-4"
      style={{
        backgroundColor: "var(--color-surface)",
        borderBottom: "1px solid var(--color-border)",
        boxShadow: "var(--shadow-sm)",
        padding: "0.6rem 0",
      }}
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/dashboard" style={{ padding: 0 }}>
          <img
            src="newlogo2.jpg"
            alt="CSD Logo"
            style={{ maxHeight: "46px", width: "auto", objectFit: "contain" }}
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="top-nav-collapse"
          style={{
            border: "1px solid var(--color-border)",
            borderRadius: "var(--radius-sm)",
          }}
        />

        <Navbar.Collapse id="top-nav-collapse">
          <Nav className="ms-auto mt-2 mb-1 gap-1 flex-wrap">
            {user && user.role === "admin" ? (
              <>
                <NavLink to="/admin/dashboard"     icon={RxDashboard}>Admin Dashboard</NavLink>
                <NavLink to="/admin/projects"      icon={FaProjectDiagram}>Projects</NavLink>
                <NavLink to="/admin/students"      icon={FaUsers}>Students</NavLink>
                <NavLink to="/admin/announcements" icon={FaBullhorn}>Announcements</NavLink>
                <NavLink to="/messages"            icon={FaComments}>Direct Messages</NavLink>
              </>
            ) : (
              <>
                <NavLink to="/dashboard"    icon={RxDashboard}>Dashboard</NavLink>
                <NavLink to="/myprojects"   icon={LuFolderHeart}>My Projects</NavLink>
                <NavLink to="/browse"       icon={TbHeartSearch}>Browse</NavLink>
                <NavLink to="/announcements" icon={FaBullhorn}>Announcements</NavLink>
                <NavLink to="/messages"     icon={FaComments}>Direct Messages</NavLink>
              </>
            )}
            <NavLink to="/settings" icon={RiSettings5Line}>Settings</NavLink>
            <NavLink to="/help"     icon={IoMdHelpCircleOutline}>Tech Support</NavLink>
          </Nav>

          <hr style={{ borderColor: "var(--color-border)", margin: "0.5rem 0" }} />

          <div
            onClick={handleLogout}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.6rem",
              cursor: "pointer",
              color: "var(--color-red)",
              fontWeight: 600,
              fontSize: "0.9rem",
              padding: "0.5rem 0.5rem",
              borderRadius: "var(--radius-md)",
              width: "fit-content",
              marginBottom: "0.5rem",
              transition: "background var(--transition)",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(193,57,43,0.07)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
          >
            <RxPinLeft size={18} />
            <span>Logout</span>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default TopNavBar;
